import PropTypes from "prop-types"

/**
 * PropTypes for Billing CreateCredentialModal component.
 */
export const billingCreateCredentialModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSuccess: PropTypes.func.isRequired,
	addToast: PropTypes.func.isRequired,
}

/**
 * PropTypes for Billing EditCredentialModal component.
 */
export const billingEditCredentialModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	credential: PropTypes.shape({
		documentId: PropTypes.string,
		name: PropTypes.string,
		username: PropTypes.string,
		client_id: PropTypes.string,
		company_id: PropTypes.number,
		document_set_id: PropTypes.number,
		default_customer_id: PropTypes.number,
		default_product_id: PropTypes.number,
		default_tax_id: PropTypes.number,
		default_tax_rate: PropTypes.number,
		default_payment_method_id: PropTypes.number,
	}),
	onSave: PropTypes.func.isRequired,
}

/**
 * PropTypes for Billing DeleteCredentialModal component.
 */
export const billingDeleteCredentialModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	credential: PropTypes.shape({
		documentId: PropTypes.string,
		name: PropTypes.string,
		username: PropTypes.string,
	}),
	onConfirm: PropTypes.func.isRequired,
	addToast: PropTypes.func.isRequired,
}

/**
 * PropTypes for Billing credentials sidebar section.
 */
export const billingSidebarSectionPropTypes = {
	credential: PropTypes.shape({
		documentId: PropTypes.string,
		name: PropTypes.string,
		username: PropTypes.string,
		client_id: PropTypes.string,
		company_id: PropTypes.number,
		document_set_id: PropTypes.number,
		is_active: PropTypes.bool,
		createdAt: PropTypes.string,
	}),
	filters: PropTypes.shape({
		status: PropTypes.string.isRequired,
	}).isRequired,
	onFilterChange: PropTypes.func.isRequired,
	statusOptions: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		})
	).isRequired,
	onEditClick: PropTypes.func.isRequired,
	onActivate: PropTypes.func.isRequired,
	onDeactivate: PropTypes.func.isRequired,
	onValidate: PropTypes.func.isRequired,
	isValidating: PropTypes.bool,
	isUpdatingStatus: PropTypes.bool,
	onDeleteClick: PropTypes.func.isRequired,
}
